module.exports = __webpack_public_path__ + "img/Menu_Abos_Konfig_FR.776f2ed9.jpg";